import React from 'react';
import { useSelector } from 'react-redux';

import THypothesis from './OneSampleTHypothesis/Component';
import TConfidenceInterval from './OneSampleTConfidenceInterval/Component';
import TwoTHypothesis from './TwoSampleTHypothesis/Component';
import TwoTConfidenceInterval from './TwoSampleTConfidenceInterval/Component';
import ProportionHypothesis from './OneSampleProportionHypothesis/Component';
import ProportionConfidenceInterval from './OneSampleProportionConfidenceInterval/Component';
import TwoProportionHypothesis from './TwoSampleProportionHypothesis/Component';
import TwoProportionConfidenceInterval from './TwoSampleProportionConfidenceInterval/Component';
import PairedTHypothesis from './pairedTHypothesis/Component';
import PairedTConfidenceInterval from './pairedTConfidenceInterval/Component';
import ChiSquareGoodnessOfFit from './ChiSquareGoodnessOfFit/Component';
import ChiSquareTestForIndependence from './ChiSquareTestForIndependence/Component';
import Anova from './Anova';

import {
  getProcedure,
  getInferentialStatistics
} from 'store/scenes/inferentialStatistics/selectors';

import {
  HYPOTHESIS_MEAN,
  ONE_SAMPLE_T,
  ONE_SAMPLE_PROPORTION,
  TWO_SAMPLE_T,
  TWO_SAMPLE_PROPORTION,
  PAIRED_T,
  CHI_SQUARE_GOODNESS_OF_FIT,
  CHI_SQUARE_TEST_FOR_HOMOGENEITY,
  CHI_SQUARE_TEST_FOR_INDEPENDENCE,
  ANOVA
} from '../../Constants';

const ProcedureContainer = () => {
  const procedure = useSelector(state => getProcedure(state));
  const inferentialStatistics = useSelector(state => getInferentialStatistics(state));

  if (inferentialStatistics === ONE_SAMPLE_T) {
    return procedure === HYPOTHESIS_MEAN ? (
      <THypothesis />
    ) : (
      <TConfidenceInterval />
    );
  } else if (inferentialStatistics === ONE_SAMPLE_PROPORTION) {
    return procedure === HYPOTHESIS_MEAN ? (
      <ProportionHypothesis />
    ) : (
      <ProportionConfidenceInterval />
    );
  } else if (inferentialStatistics === TWO_SAMPLE_T) {
    return procedure === HYPOTHESIS_MEAN ? (
      <TwoTHypothesis />
    ) : (
      <TwoTConfidenceInterval />
    );
  } else if (inferentialStatistics === TWO_SAMPLE_PROPORTION) {
    return procedure === HYPOTHESIS_MEAN ? (
      <TwoProportionHypothesis />
    ) : (
      <TwoProportionConfidenceInterval />
    );
  } else if (inferentialStatistics === PAIRED_T) {
    return procedure === HYPOTHESIS_MEAN ? (
      <PairedTHypothesis />
    ) : (
      <PairedTConfidenceInterval />
    );
  } else if (inferentialStatistics === CHI_SQUARE_GOODNESS_OF_FIT) {
    return <ChiSquareGoodnessOfFit />;
  } else if (inferentialStatistics === CHI_SQUARE_TEST_FOR_INDEPENDENCE || inferentialStatistics === CHI_SQUARE_TEST_FOR_HOMOGENEITY) {
    return <ChiSquareTestForIndependence isTestForHomogeneity={inferentialStatistics === CHI_SQUARE_TEST_FOR_HOMOGENEITY} />;
  } else if (inferentialStatistics === ANOVA) {
    return <Anova />;
  }
  return null;
};

export default ProcedureContainer;
